
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/cities'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderGroup from '../HeaderGroup/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    HeaderGroup
  }
})
export default class RecommdCard extends Vue {
  @Prop({ required: true, type: Object }) readonly dataSource!: CityTypeInfo & { subTitle: string }

  get EnumCityStatus() {
    return EnumCityStatus
  }

  get btnText() {
    return this.dataSource.status === EnumCityStatus.Assistance
      ? '助力'
      : this.dataSource.status === EnumCityStatus.Recruitment
        ? '负责人招募'
        : ''
  }

  join: boolean = this.dataSource.id === 0 || this.dataSource.id === 2 ? true : false

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
